export default class QualityOverviewTableStatsDto {
    constructor(obj) {
        this.id = obj[0]
        this.start = obj[1]
        this.end = obj[2]
        this.operations = obj[3]
        this.analysis = obj[4]
    }
}